import { FIZZY_CLASSES } from '../constants/classNames';
import ReadAloudSwitch from './ReadAloudSwitch';
import '../styles/FizzySpeech.css';

/**
 * Fizzy's speech bubble inside the mixing card: reaction explanations, tips and safety notes.
 */
export default function FizzySpeech({ assistantName, message, isReadAloudOn, canReadAloud, onToggleReadAloud, onShowTip }) {
  return (
    <div className={FIZZY_CLASSES.root}>
      <span className={FIZZY_CLASSES.name}>{assistantName} says</span>
      <div className={FIZZY_CLASSES.bubble} aria-live="polite">
        {message.title && <h3 className={FIZZY_CLASSES.title}>{message.title}</h3>}
        <p className={FIZZY_CLASSES.text}>{message.text}</p>
        {message.funFact && (
          <p className={FIZZY_CLASSES.funFact}>
            <strong>Fun fact:</strong> {message.funFact}
          </p>
        )}
        {message.safetyNote && <p className={FIZZY_CLASSES.safety}>🥽 {message.safetyNote}</p>}
      </div>
      <div className={FIZZY_CLASSES.actions}>
        <ReadAloudSwitch isOn={isReadAloudOn} isAvailable={canReadAloud} onToggle={onToggleReadAloud} />
        <button type="button" className={FIZZY_CLASSES.actionButton} onClick={onShowTip}>
          💡 Give me a tip
        </button>
      </div>
    </div>
  );
}
